var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.1957V19.619C16 19.9607 15.7648 20.2577 15.4321 20.3361L8.16905 22.0495C8.05784 22.0756 7.9421 22.0756 7.83089 22.0495L0.567844 20.3361C0.406255 20.298 0.262266 20.2064 0.159204 20.0763C0.0561416 19.9461 4.43215e-05 19.785 0 19.619L0 11.1957C0 10.9902 0.085125 10.8013 0.224906 10.6658H15.7743V10.665C15.8457 10.7337 15.9025 10.8161 15.9413 10.9073C15.9801 10.9985 16 11.0966 16 11.1957Z",
    fill: "url(#paint0_linear_3555_79890)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.0818V12.2998H8.82453L8 13.0818Z",
    fill: "url(#paint1_linear_3555_79890)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7746 10.6658H11.2783V21.3161L15.4325 20.3361C15.5941 20.298 15.7381 20.2064 15.8411 20.0762C15.9442 19.9461 16.0003 19.7849 16.0003 19.6189V11.1957C16.0004 11.0966 15.9804 10.9985 15.9416 10.9073C15.9029 10.8161 15.846 10.7337 15.7746 10.665V10.6658Z",
    fill: "url(#paint2_linear_3555_79890)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 10.666V22.0691C7.94339 22.0691 7.88677 22.0627 7.83094 22.0497L0.567844 20.3363C0.406255 20.2982 0.262266 20.2066 0.159204 20.0765C0.0561416 19.9463 4.43215e-05 19.7852 0 19.6191L0 11.1958C0 10.9903 0.085125 10.8014 0.224906 10.666H8.00002Z",
    fill: "url(#paint3_linear_3555_79890)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 10.666V22.0691C7.94339 22.0691 7.88677 22.0627 7.83094 22.0497L0.567844 20.3363C0.406255 20.2982 0.262266 20.2066 0.159204 20.0765C0.0561416 19.9463 4.43215e-05 19.7852 0 19.6191L0 11.1958C0 10.9903 0.085125 10.8014 0.224906 10.666H8.00002Z",
    fill: "url(#paint4_linear_3555_79890)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 16.8754V22.0687C7.94339 22.0687 7.88677 22.0623 7.83094 22.0493L0.567844 20.3359C0.406255 20.2978 0.262266 20.2062 0.159204 20.0761C0.0561416 19.9459 4.43215e-05 19.7848 0 19.6188L0 15.0859L7.1835 16.7803C7.45108 16.8435 7.72508 16.8754 8.00002 16.8754Z",
    fill: "url(#paint5_linear_3555_79890)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.8754V22.0687C8.05662 22.0687 8.11325 22.0624 8.16908 22.0493L15.4322 20.3359C15.5938 20.2978 15.7378 20.2062 15.8408 20.0761C15.9439 19.9459 16 19.7848 16 19.6188V15.0859L8.81652 16.7804C8.54893 16.8435 8.27493 16.8754 8 16.8754Z",
    fill: "url(#paint6_linear_3555_79890)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7742 10.6655L8.42557 12.3991C8.14564 12.4652 7.85415 12.4652 7.57423 12.3991L0.225586 10.6655C0.320644 10.5735 0.438668 10.5088 0.567305 10.4782L7.83077 8.76473C7.94198 8.73858 8.05773 8.73858 8.16893 8.76473L10.881 9.40463V9.7313H12.2666L15.4324 10.4781C15.561 10.5088 15.6791 10.5735 15.7742 10.6655Z",
    fill: "url(#paint7_linear_3555_79890)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.881 9.40467V9.73134L3.57321 11.4555L0.225586 10.6655C0.320644 10.5735 0.438668 10.5088 0.567305 10.4782L7.83077 8.76473C7.94198 8.73858 8.05773 8.73858 8.16893 8.76473L10.881 9.40467Z",
    fill: "url(#paint8_linear_3555_79890)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8816 9.4043L3.03461 11.2557C2.991 11.266 2.95214 11.2907 2.92433 11.3258C2.89652 11.3609 2.88138 11.4044 2.88137 11.4492L2.88086 13.9105C2.88086 13.9641 2.91775 14.0107 2.96992 14.023L4.12464 14.2952C4.14161 14.2992 4.15927 14.2993 4.17628 14.2955C4.1933 14.2917 4.20924 14.2841 4.22291 14.2733C4.23659 14.2625 4.24763 14.2487 4.25523 14.233C4.26282 14.2173 4.26676 14.2001 4.26677 14.1827V11.7622C4.26676 11.7214 4.28057 11.6817 4.30594 11.6496C4.33131 11.6176 4.36676 11.5951 4.40655 11.5857L12.2671 9.7313L10.8816 9.4043Z",
    fill: "url(#paint9_linear_3555_79890)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61434 11.0653L4.40634 11.5861C4.37475 11.5936 4.34576 11.6095 4.32238 11.632L2.94238 11.3065C2.96795 11.2817 2.99967 11.2642 3.03426 11.2558L5.22801 10.7383L6.61434 11.0653Z",
    fill: "url(#paint10_linear_3555_79890)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94171 11.3066L4.32129 11.6321C4.30374 11.6491 4.28979 11.6694 4.28026 11.6918C4.27073 11.7143 4.26583 11.7384 4.26584 11.7628V14.1831C4.26587 14.2005 4.26195 14.2178 4.25437 14.2335C4.24678 14.2492 4.23573 14.263 4.22204 14.2738C4.20835 14.2846 4.19239 14.2922 4.17535 14.296C4.15831 14.2997 4.14064 14.2996 4.12366 14.2955L2.96899 14.0235C2.94365 14.0175 2.92106 14.0032 2.90489 13.9828C2.88872 13.9624 2.87991 13.9371 2.87988 13.9111L2.88026 11.4497C2.88025 11.4229 2.8857 11.3964 2.89627 11.3718C2.90683 11.3472 2.92229 11.3251 2.94171 11.3066Z",
    fill: "url(#paint11_linear_3555_79890)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.88105 12.7256L2.88086 13.9107C2.88086 13.9642 2.9177 14.0109 2.96997 14.0232L4.12464 14.2952C4.14161 14.2993 4.15929 14.2994 4.17633 14.2957C4.19338 14.2919 4.20935 14.2843 4.22304 14.2735C4.23673 14.2627 4.24778 14.2489 4.25536 14.2332C4.26294 14.2174 4.26686 14.2002 4.26681 14.1827V12.7256H2.88105V12.7256Z",
    fill: "url(#paint12_linear_3555_79890)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0.876445 19.28L4.0602 20.0311C4.08485 20.0369 4.11051 20.037 4.13524 20.0315C4.15997 20.026 4.18314 20.015 4.203 19.9993C4.22287 19.9836 4.23892 19.9636 4.24996 19.9408C4.26099 19.9179 4.26673 19.8929 4.26673 19.8676V18.1191C4.26673 18.0813 4.25396 18.0446 4.23048 18.0149C4.20699 17.9852 4.17418 17.9644 4.13735 17.9557L0.953602 17.2047C0.928944 17.1989 0.903289 17.1987 0.878558 17.2042C0.853827 17.2097 0.830661 17.2207 0.810794 17.2364C0.790928 17.2522 0.774876 17.2722 0.76384 17.295C0.752805 17.3178 0.747072 17.3428 0.74707 17.3681V19.1165C0.747064 19.1544 0.759838 19.1911 0.78332 19.2208C0.806803 19.2504 0.839618 19.2713 0.876445 19.28Z",
    fill: "url(#paint13_linear_3555_79890)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0.74707 17.8633V19.116C0.747064 19.1538 0.759838 19.1905 0.78332 19.2202C0.806803 19.2499 0.839618 19.2707 0.876445 19.2794L4.0602 20.0305C4.08485 20.0363 4.11051 20.0365 4.13524 20.031C4.15997 20.0255 4.18314 20.0145 4.203 19.9987C4.22287 19.983 4.23892 19.963 4.24996 19.9402C4.26099 19.9174 4.26673 19.8924 4.26673 19.867V18.6936L0.74707 17.8633Z",
    fill: "url(#paint14_linear_3555_79890)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13727 17.9556L2.52051 17.5742V19.6678L4.06016 20.031C4.08482 20.0368 4.11048 20.037 4.13521 20.0315C4.15994 20.026 4.1831 20.015 4.20297 19.9993C4.22284 19.9835 4.23889 19.9635 4.24993 19.9407C4.26096 19.9179 4.26669 19.8929 4.2667 19.8676V18.119C4.26668 18.0812 4.2539 18.0445 4.23041 18.0148C4.20692 17.9851 4.1741 17.9643 4.13727 17.9556Z",
    fill: "url(#paint15_linear_3555_79890)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26465 19.6055V19.6091C9.26465 19.6324 9.26992 19.6554 9.28007 19.6764C9.29022 19.6974 9.30499 19.7158 9.32326 19.7302C9.34154 19.7447 9.36285 19.7549 9.3856 19.7599C9.40835 19.765 9.43195 19.7648 9.45463 19.7595L11.7394 19.2206C11.7733 19.2126 11.8035 19.1934 11.8251 19.1661C11.8467 19.1388 11.8585 19.105 11.8585 19.0702V19.0666C11.8585 19.0433 11.8532 19.0203 11.8431 18.9993C11.8329 18.9783 11.8181 18.9599 11.7999 18.9455C11.7816 18.931 11.7603 18.9209 11.7375 18.9158C11.7148 18.9107 11.6912 18.9109 11.6685 18.9162L9.38371 19.4552C9.34983 19.4632 9.31964 19.4824 9.29803 19.5096C9.27642 19.5369 9.26466 19.5707 9.26465 19.6055Z",
    fill: "url(#paint16_linear_3555_79890)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45463 20.3642L10.5935 20.0956C10.6274 20.0876 10.6576 20.0684 10.6792 20.0411C10.7008 20.0138 10.7126 19.98 10.7126 19.9452V19.9416C10.7126 19.9183 10.7073 19.8953 10.6971 19.8743C10.687 19.8533 10.6722 19.8349 10.654 19.8205C10.6357 19.806 10.6144 19.7959 10.5916 19.7908C10.5689 19.7857 10.5453 19.7859 10.5226 19.7912L9.38371 20.0599C9.34983 20.0679 9.31964 20.0871 9.29803 20.1144C9.27642 20.1417 9.26466 20.1754 9.26465 20.2103V20.2139C9.26465 20.2372 9.26993 20.2602 9.28009 20.2811C9.29024 20.3021 9.30501 20.3205 9.32328 20.335C9.34155 20.3494 9.36286 20.3596 9.38561 20.3646C9.40836 20.3697 9.43195 20.3695 9.45463 20.3642Z",
    fill: "url(#paint17_linear_3555_79890)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24 13.0824V21.5057C24 21.8474 23.7648 22.1444 23.4322 22.2228L16.1691 23.9362C16.0579 23.9623 15.9421 23.9623 15.8309 23.9362L8.56784 22.2228C8.40625 22.1847 8.26226 22.0931 8.15919 21.963C8.05613 21.8328 8.00004 21.6717 8 21.5056V13.0824C8 12.8769 8.08513 12.688 8.22491 12.5526H23.7743V12.5518C23.9149 12.6872 24 12.8765 24 13.0824Z",
    fill: "url(#paint18_linear_3555_79890)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7746 12.5526H19.2783V23.2028L23.4325 22.2228C23.5941 22.1847 23.7381 22.0931 23.8411 21.963C23.9442 21.8328 24.0003 21.6717 24.0003 21.5056V13.0824C24.0004 12.9833 23.9804 12.8852 23.9416 12.794C23.9029 12.7028 23.846 12.6204 23.7746 12.5518V12.5526Z",
    fill: "url(#paint19_linear_3555_79890)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.5518V23.9548C15.9434 23.9548 15.8868 23.9485 15.8309 23.9354L8.56784 22.222C8.40625 22.1839 8.26226 22.0923 8.15919 21.9622C8.05613 21.832 8.00004 21.6709 8 21.5048V13.0816C8 12.8761 8.08513 12.6872 8.22491 12.5518H16Z",
    fill: "url(#paint20_linear_3555_79890)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.5518V23.9548C15.9434 23.9548 15.8868 23.9485 15.8309 23.9354L8.56784 22.222C8.40625 22.1839 8.26226 22.0923 8.15919 21.9622C8.05613 21.832 8.00004 21.6709 8 21.5048V13.0816C8 12.8761 8.08513 12.6872 8.22491 12.5518H16Z",
    fill: "url(#paint21_linear_3555_79890)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.7622V23.9554C15.9434 23.9554 15.8868 23.9491 15.8309 23.936L8.56784 22.2226C8.40625 22.1845 8.26226 22.093 8.15919 21.9628C8.05613 21.8326 8.00004 21.6715 8 21.5055V16.9727L15.1835 18.667C15.4511 18.7302 15.7251 18.7622 16 18.7622Z",
    fill: "url(#paint22_linear_3555_79890)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.7622V23.9554C16.0566 23.9554 16.1132 23.9491 16.1691 23.936L23.4322 22.2226C23.5938 22.1845 23.7378 22.093 23.8408 21.9628C23.9439 21.8326 24 21.6715 24 21.5055V16.9727L16.8165 18.667C16.5489 18.7303 16.2749 18.7622 16 18.7622Z",
    fill: "url(#paint23_linear_3555_79890)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7741 12.5522L16.4255 14.2858C16.1456 14.352 15.8541 14.352 15.5742 14.2858L8.22559 12.5522C8.32064 12.4603 8.43867 12.3956 8.5673 12.3649L15.8308 10.6515C15.942 10.6253 16.0577 10.6253 16.1689 10.6515L18.881 11.2913V11.618H20.2666L23.4324 12.3648C23.561 12.3955 23.6791 12.4602 23.7741 12.5522Z",
    fill: "url(#paint24_linear_3555_79890)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7741 12.5522L16.4255 14.2858C16.1456 14.352 15.8541 14.352 15.5742 14.2858L8.22559 12.5522C8.32064 12.4603 8.43867 12.3956 8.5673 12.3649L15.8308 10.6515C15.942 10.6253 16.0577 10.6253 16.1689 10.6515L18.881 11.2913V11.618H20.2666L23.4324 12.3648C23.561 12.3955 23.6791 12.4602 23.7741 12.5522Z",
    fill: "url(#paint25_linear_3555_79890)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M18.881 11.2914V11.6181L11.5732 13.3422L8.22559 12.5522C8.32064 12.4603 8.43867 12.3956 8.56731 12.3649L15.8308 10.6515C15.942 10.6253 16.0577 10.6253 16.1689 10.6515L18.881 11.2914Z",
    fill: "url(#paint26_linear_3555_79890)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8816 11.291L11.0346 13.1424C10.991 13.1527 10.9521 13.1774 10.9243 13.2125C10.8965 13.2476 10.8814 13.2911 10.8814 13.3359L10.8809 15.7972C10.8809 15.8508 10.9177 15.8974 10.9699 15.9097L12.1246 16.1819C12.1416 16.1859 12.1593 16.186 12.1763 16.1822C12.1933 16.1784 12.2092 16.1709 12.2229 16.16C12.2366 16.1492 12.2476 16.1354 12.2552 16.1197C12.2628 16.1041 12.2668 16.0868 12.2668 16.0694V13.649C12.2668 13.6081 12.2806 13.5684 12.3059 13.5364C12.3313 13.5043 12.3668 13.4818 12.4065 13.4724L20.2671 11.618L18.8816 11.291Z",
    fill: "url(#paint27_linear_3555_79890)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8816 11.291L11.0347 13.1421C10.9991 13.1505 10.9672 13.1684 10.9424 13.1927L12.3219 13.5185C12.3449 13.496 12.3735 13.4801 12.4063 13.4721L20.2668 11.6177L18.8816 11.291Z",
    fill: "url(#paint28_linear_3555_79890)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6143 12.952L12.4063 13.4728C12.3747 13.4803 12.3458 13.4962 12.3224 13.5187L10.9424 13.1932C10.968 13.1685 10.9997 13.151 11.0343 13.1425L13.228 12.625L14.6143 12.952Z",
    fill: "url(#paint29_linear_3555_79890)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9417 13.1924L12.3213 13.5179C12.3037 13.5348 12.2898 13.5551 12.2803 13.5776C12.2707 13.6 12.2658 13.6242 12.2658 13.6486V16.0688C12.2659 16.0863 12.262 16.1035 12.2544 16.1192C12.2468 16.135 12.2357 16.1487 12.2221 16.1596C12.2084 16.1704 12.1924 16.178 12.1754 16.1817C12.1583 16.1855 12.1406 16.1853 12.1237 16.1813L10.969 15.9093C10.9436 15.9033 10.9211 15.8889 10.9049 15.8685C10.8887 15.8481 10.8799 15.8228 10.8799 15.7968L10.8803 13.3354C10.8803 13.3086 10.8857 13.2822 10.8963 13.2576C10.9068 13.233 10.9223 13.2108 10.9417 13.1924Z",
    fill: "url(#paint30_linear_3555_79890)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8801 14.6124L10.8799 15.7974C10.8799 15.8509 10.9167 15.8976 10.969 15.9099L12.1237 16.1819C12.1406 16.186 12.1583 16.1861 12.1754 16.1824C12.1924 16.1786 12.2084 16.171 12.2221 16.1602C12.2357 16.1494 12.2468 16.1356 12.2544 16.1199C12.262 16.1042 12.2659 16.0869 12.2658 16.0695V14.6123H10.8801V14.6124Z",
    fill: "url(#paint31_linear_3555_79890)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87645 21.1657L12.0602 21.9168C12.0849 21.9226 12.1105 21.9228 12.1352 21.9173C12.16 21.9118 12.1831 21.9008 12.203 21.885C12.2229 21.8693 12.2389 21.8493 12.25 21.8265C12.261 21.8037 12.2667 21.7787 12.2667 21.7534V20.0049C12.2667 19.967 12.254 19.9303 12.2305 19.9006C12.207 19.871 12.1742 19.8501 12.1374 19.8414L8.9536 19.0904C8.92894 19.0846 8.90329 19.0844 8.87856 19.0899C8.85383 19.0954 8.83066 19.1065 8.81079 19.1222C8.79093 19.1379 8.77488 19.1579 8.76384 19.1807C8.75281 19.2035 8.74707 19.2285 8.74707 19.2539V21.0023C8.74706 21.0401 8.75984 21.0768 8.78332 21.1065C8.8068 21.1362 8.83962 21.157 8.87645 21.1657Z",
    fill: "url(#paint32_linear_3555_79890)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74707 19.75V21.0027C8.74706 21.0405 8.75984 21.0773 8.78332 21.1069C8.8068 21.1366 8.83962 21.1575 8.87645 21.1661L12.0602 21.9172C12.0849 21.923 12.1105 21.9232 12.1352 21.9177C12.16 21.9122 12.1831 21.9012 12.203 21.8855C12.2229 21.8697 12.2389 21.8497 12.25 21.8269C12.261 21.8041 12.2667 21.7791 12.2667 21.7538V20.5803L8.74707 19.75Z",
    fill: "url(#paint33_linear_3555_79890)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1373 19.8413L10.5205 19.46V21.5535L12.0602 21.9168C12.0848 21.9226 12.1105 21.9228 12.1352 21.9173C12.1599 21.9118 12.1831 21.9007 12.203 21.885C12.2228 21.8693 12.2389 21.8493 12.2499 21.8265C12.261 21.8037 12.2667 21.7787 12.2667 21.7533V20.0048C12.2667 19.967 12.2539 19.9302 12.2304 19.9006C12.2069 19.8709 12.1741 19.85 12.1373 19.8413Z",
    fill: "url(#paint34_linear_3555_79890)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2646 21.4923V21.4958C17.2646 21.5191 17.2699 21.5421 17.2801 21.5631C17.2902 21.5841 17.305 21.6025 17.3233 21.617C17.3415 21.6314 17.3628 21.6416 17.3856 21.6466C17.4083 21.6517 17.4319 21.6515 17.4546 21.6462L19.7394 21.1073C19.7733 21.0993 19.8035 21.0801 19.8251 21.0528C19.8467 21.0255 19.8585 20.9917 19.8585 20.9569V20.9533C19.8585 20.93 19.8532 20.907 19.8431 20.886C19.8329 20.8651 19.8181 20.8466 19.7999 20.8322C19.7816 20.8177 19.7603 20.8076 19.7375 20.8025C19.7148 20.7975 19.6912 20.7976 19.6685 20.803L17.3837 21.3419C17.3498 21.3499 17.3196 21.3691 17.298 21.3963C17.2764 21.4236 17.2646 21.4574 17.2646 21.4923Z",
    fill: "url(#paint35_linear_3555_79890)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4546 22.2509L18.5935 21.9823C18.6274 21.9743 18.6576 21.9551 18.6792 21.9278C18.7008 21.9005 18.7126 21.8668 18.7126 21.8319V21.8283C18.7126 21.805 18.7073 21.782 18.6971 21.761C18.687 21.7401 18.6722 21.7216 18.654 21.7072C18.6357 21.6927 18.6144 21.6826 18.5916 21.6775C18.5689 21.6725 18.5453 21.6726 18.5226 21.678L17.3837 21.9466C17.3498 21.9546 17.3196 21.9738 17.298 22.0011C17.2764 22.0284 17.2647 22.0622 17.2646 22.097V22.1006C17.2647 22.1239 17.2699 22.1469 17.2801 22.1679C17.2902 22.1888 17.305 22.2072 17.3233 22.2217C17.3416 22.2362 17.3629 22.2463 17.3856 22.2514C17.4084 22.2564 17.432 22.2563 17.4546 22.2509Z",
    fill: "url(#paint36_linear_3555_79890)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7657 2.49547V10.9188C19.7657 11.2605 19.5304 11.5575 19.1978 11.6359L11.9347 13.3493C11.8235 13.3754 11.7078 13.3754 11.5966 13.3493L4.33347 11.6359C4.17188 11.5978 4.02788 11.5063 3.92482 11.3761C3.82176 11.2459 3.76566 11.0848 3.76562 10.9188V2.49547C3.76562 2.28997 3.85075 2.10106 3.99053 1.96564H19.5399V1.96484C19.6113 2.03352 19.6682 2.11592 19.707 2.20711C19.7457 2.29829 19.7657 2.39638 19.7657 2.49547Z",
    fill: "url(#paint37_linear_3555_79890)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5402 1.96569H15.0439V12.6159L19.1981 11.6359C19.3597 11.5978 19.5037 11.5063 19.6068 11.3761C19.7098 11.2459 19.7659 11.0848 19.7659 10.9188V2.49547C19.766 2.39638 19.7461 2.2983 19.7073 2.20711C19.6685 2.11593 19.6117 2.03352 19.5402 1.96484V1.96569Z",
    fill: "url(#paint38_linear_3555_79890)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7656 1.96489V13.3679C11.709 13.3679 11.6524 13.3616 11.5966 13.3485L4.33347 11.6351C4.17188 11.597 4.02788 11.5055 3.92482 11.3753C3.82176 11.2451 3.76566 11.084 3.76562 10.918V2.49467C3.76562 2.28917 3.85075 2.10027 3.99053 1.96484L11.7656 1.96489Z",
    fill: "url(#paint39_linear_3555_79890)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7656 8.17524V13.3685C11.709 13.3685 11.6524 13.3622 11.5966 13.3491L4.33347 11.6357C4.17188 11.5976 4.02788 11.506 3.92482 11.3759C3.82176 11.2457 3.76566 11.0846 3.76562 10.9186V6.38574L10.9491 8.08013C11.2167 8.14333 11.4907 8.17525 11.7656 8.17524Z",
    fill: "url(#paint40_linear_3555_79890)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7656 8.17524V13.3685C11.8222 13.3685 11.8789 13.3622 11.9347 13.3491L19.1978 11.6357C19.3594 11.5976 19.5034 11.506 19.6064 11.3759C19.7095 11.2457 19.7656 11.0846 19.7656 10.9186V6.38574L12.5821 8.08018C12.3146 8.14334 12.0406 8.17525 11.7656 8.17524Z",
    fill: "url(#paint41_linear_3555_79890)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5398 1.96527L12.1912 3.6989C11.9113 3.76504 11.6198 3.76504 11.3399 3.6989L3.99121 1.96527C4.08627 1.87334 4.20429 1.80864 4.33293 1.77796L11.5964 0.0645396C11.7076 0.0383826 11.8234 0.0383826 11.9346 0.0645396L14.6466 0.70443V1.0311H16.0322L19.198 1.77791C19.3267 1.80858 19.4447 1.8733 19.5398 1.96527Z",
    fill: "url(#paint42_linear_3555_79890)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6466 0.70443V1.0311L7.33884 2.75521L3.99121 1.96527C4.08627 1.87334 4.20429 1.80864 4.33293 1.77796L11.5964 0.0645396C11.7076 0.0383826 11.8234 0.0383826 11.9346 0.0645396L14.6466 0.70443Z",
    fill: "url(#paint43_linear_3555_79890)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6463 0.704102L6.79926 2.55548C6.75565 2.56576 6.71679 2.59047 6.68898 2.6256C6.66117 2.66073 6.64603 2.70422 6.64602 2.74902L6.64551 5.21029C6.64551 5.26391 6.6824 5.31051 6.73457 5.32284L7.88929 5.59499C7.90626 5.59899 7.92391 5.59911 7.94093 5.59532C7.95795 5.59153 7.97389 5.58394 7.98756 5.57312C8.00123 5.5623 8.01228 5.54853 8.01987 5.53283C8.02747 5.51714 8.03141 5.49993 8.03141 5.48249V3.06205C8.03141 3.02118 8.04521 2.9815 8.07059 2.94945C8.09596 2.9174 8.13141 2.89486 8.17119 2.88548L16.0317 1.0311L14.6463 0.704102Z",
    fill: "url(#paint44_linear_3555_79890)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M10.38 2.36513L8.17196 2.88587C8.14037 2.8934 8.11138 2.90926 8.08801 2.9318L6.70801 2.6063C6.73358 2.58154 6.7653 2.56405 6.79988 2.55563L8.99363 2.03809L10.38 2.36513Z",
    fill: "url(#paint45_linear_3555_79890)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70734 2.60547L8.08691 2.93097C8.06937 2.94791 8.05541 2.96821 8.04588 2.99067C8.03636 3.01312 8.03145 3.03726 8.03146 3.06166V5.48191C8.03151 5.49936 8.02759 5.5166 8.02001 5.53232C8.01243 5.54804 8.00137 5.56183 7.98769 5.57266C7.974 5.58349 7.95803 5.59107 7.94098 5.59483C7.92394 5.59858 7.90626 5.59842 7.88929 5.59436L6.73462 5.32234C6.70927 5.31637 6.68669 5.30202 6.67051 5.28161C6.65434 5.2612 6.64553 5.23593 6.64551 5.20989L6.64588 2.74848C6.64588 2.72172 6.65132 2.69524 6.66189 2.67065C6.67246 2.64606 6.68792 2.62389 6.70734 2.60547Z",
    fill: "url(#paint46_linear_3555_79890)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6457 4.02539L6.64551 5.21048C6.64551 5.26397 6.68235 5.31066 6.73462 5.32294L7.88929 5.59495C7.90626 5.59902 7.92394 5.59918 7.94098 5.59542C7.95803 5.59166 7.974 5.58408 7.98768 5.57325C8.00137 5.56243 8.01243 5.54863 8.02001 5.53291C8.02759 5.51719 8.03151 5.49995 8.03146 5.4825V4.02539H6.6457Z",
    fill: "url(#paint47_linear_3555_79890)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64109 10.5798L7.82484 11.3309C7.8495 11.3367 7.87516 11.3369 7.89989 11.3314C7.92462 11.3258 7.94778 11.3148 7.96765 11.2991C7.98752 11.2834 8.00357 11.2634 8.0146 11.2406C8.02564 11.2178 8.03137 11.1927 8.03137 11.1674V9.41893C8.03138 9.38109 8.01861 9.34436 7.99512 9.31469C7.97164 9.28502 7.93883 9.26416 7.902 9.25547L4.71825 8.50449C4.69359 8.49867 4.66794 8.49851 4.64321 8.50401C4.61848 8.50951 4.59531 8.52053 4.57544 8.53625C4.55558 8.55198 4.53952 8.57199 4.52849 8.5948C4.51745 8.6176 4.51172 8.64261 4.51172 8.66794V10.4163C4.5117 10.4542 4.52446 10.4909 4.54795 10.5206C4.57143 10.5503 4.60426 10.5711 4.64109 10.5798Z",
    fill: "url(#paint48_linear_3555_79890)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51172 9.16309V10.4158C4.51171 10.4536 4.52449 10.4903 4.54797 10.52C4.57145 10.5497 4.60427 10.5705 4.64109 10.5792L7.82484 11.3303C7.8495 11.3361 7.87516 11.3363 7.89989 11.3308C7.92462 11.3253 7.94778 11.3143 7.96765 11.2985C7.98752 11.2828 8.00357 11.2628 8.01461 11.24C8.02564 11.2172 8.03137 11.1922 8.03137 11.1669V9.99338L4.51172 9.16309Z",
    fill: "url(#paint49_linear_3555_79890)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90192 9.2554L6.28516 8.87402V10.9676L7.82481 11.3308C7.84947 11.3367 7.87513 11.3368 7.89986 11.3313C7.92459 11.3258 7.94775 11.3148 7.96762 11.2991C7.98749 11.2833 8.00354 11.2633 8.01457 11.2405C8.02561 11.2177 8.03134 11.1927 8.03134 11.1674V9.41885C8.03135 9.38101 8.01857 9.34427 7.99508 9.3146C7.97158 9.28494 7.93876 9.26407 7.90192 9.2554Z",
    fill: "url(#paint50_linear_3555_79890)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0303 10.9053V10.9089C13.0303 10.9322 13.0355 10.9552 13.0457 10.9762C13.0558 10.9972 13.0706 11.0156 13.0889 11.0301C13.1072 11.0445 13.1285 11.0547 13.1512 11.0597C13.174 11.0648 13.1976 11.0646 13.2203 11.0593L15.505 10.5204C15.5389 10.5124 15.5691 10.4932 15.5907 10.4659C15.6123 10.4386 15.6241 10.4048 15.6241 10.37V10.3664C15.6241 10.3431 15.6188 10.3201 15.6087 10.2991C15.5985 10.2781 15.5838 10.2597 15.5655 10.2453C15.5472 10.2308 15.5259 10.2207 15.5032 10.2156C15.4804 10.2105 15.4568 10.2107 15.4341 10.216L13.1493 10.755C13.1154 10.7629 13.0852 10.7821 13.0636 10.8094C13.042 10.8367 13.0303 10.8705 13.0303 10.9053Z",
    fill: "url(#paint51_linear_3555_79890)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2203 11.664L14.3591 11.3954C14.393 11.3874 14.4232 11.3682 14.4448 11.3409C14.4664 11.3136 14.4782 11.2798 14.4782 11.245V11.2414C14.4782 11.2181 14.4729 11.1951 14.4628 11.1741C14.4526 11.1531 14.4379 11.1347 14.4196 11.1203C14.4013 11.1058 14.38 11.0957 14.3572 11.0906C14.3345 11.0855 14.3109 11.0857 14.2882 11.091L13.1493 11.3597C13.1155 11.3677 13.0853 11.3869 13.0637 11.4142C13.042 11.4415 13.0303 11.4752 13.0303 11.5101V11.5137C13.0303 11.537 13.0356 11.56 13.0457 11.5809C13.0559 11.6019 13.0706 11.6203 13.0889 11.6348C13.1072 11.6492 13.1285 11.6594 13.1512 11.6644C13.174 11.6695 13.1976 11.6693 13.2203 11.664Z",
    fill: "url(#paint52_linear_3555_79890)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3555_79890",
    x1: 1.00542,
    y1: 9.8023,
    x2: 14.9502,
    y2: 20.9807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4573A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3555_79890",
    x1: 7.09944,
    y1: 12.6908,
    x2: 8.07598,
    y2: 12.6908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3555_79890",
    x1: 13.5084,
    y1: 15.9906,
    x2: 16.2207,
    y2: 15.9906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3555_79890",
    x1: 3.39694,
    y1: 14.5268,
    x2: 9.1132,
    y2: 21.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3555_79890",
    x1: 5.47214,
    y1: 14.696,
    x2: 8.12873,
    y2: 11.4379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3555_79890",
    x1: 3.82617,
    y1: 19.4755,
    x2: 3.48745,
    y2: 21.2256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3555_79890",
    x1: 12.1738,
    y1: 19.4755,
    x2: 12.5126,
    y2: 21.2257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3555_79890",
    x1: 7.94665,
    y1: 9.95559,
    x2: 8.15834,
    y2: 12.7784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4573A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3555_79890",
    x1: 5.5692,
    y1: 10.1015,
    x2: 5.72445,
    y2: 10.7507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3555_79890",
    x1: 6.59814,
    y1: 9.45539,
    x2: 7.69905,
    y2: 12.1371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3555_79890",
    x1: 4.77838,
    y1: 11.0885,
    x2: 4.77838,
    y2: 11.7065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3555_79890",
    x1: 3.92407,
    y1: 12.8027,
    x2: 4.35124,
    y2: 12.8027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3555_79890",
    x1: 3.52834,
    y1: 13.7176,
    x2: 3.44369,
    y2: 14.1974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3555_79890",
    x1: 1.4952,
    y1: 16.8755,
    x2: 3.45968,
    y2: 20.2587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3555_79890",
    x1: 2.48665,
    y1: 18.9632,
    x2: 2.33655,
    y2: 19.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3555_79890",
    x1: 3.7619,
    y1: 18.8049,
    x2: 4.27326,
    y2: 18.8049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3555_79890",
    x1: 9.94855,
    y1: 18.1007,
    x2: 10.9836,
    y2: 20.1896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3555_79890",
    x1: 9.19434,
    y1: 18.4748,
    x2: 10.2294,
    y2: 20.5637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3555_79890",
    x1: 9.00542,
    y1: 11.689,
    x2: 22.9502,
    y2: 22.8674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4573A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3555_79890",
    x1: 21.5084,
    y1: 17.8773,
    x2: 24.2206,
    y2: 17.8773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3555_79890",
    x1: 11.397,
    y1: 16.4125,
    x2: 17.1132,
    y2: 23.4837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3555_79890",
    x1: 12.2685,
    y1: 18.8303,
    x2: 10.8651,
    y2: 9.55743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3555_79890",
    x1: 11.8262,
    y1: 21.3622,
    x2: 11.4875,
    y2: 23.1123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3555_79890",
    x1: 20.1738,
    y1: 21.3622,
    x2: 20.5126,
    y2: 23.1123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3555_79890",
    x1: 15.9466,
    y1: 11.8423,
    x2: 16.1583,
    y2: 14.6651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4573A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3555_79890",
    x1: 16.5937,
    y1: 14.3518,
    x2: 15.8586,
    y2: 12.1241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3555_79890",
    x1: 13.5692,
    y1: 11.9882,
    x2: 13.7244,
    y2: 12.6375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3555_79890",
    x1: 14.5981,
    y1: 11.3421,
    x2: 15.699,
    y2: 14.0238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3555_79890",
    x1: 15.8039,
    y1: 13.2525,
    x2: 15.5811,
    y2: 12.3057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3555_79890",
    x1: 12.7784,
    y1: 12.9752,
    x2: 12.7784,
    y2: 13.5932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3555_79890",
    x1: 11.9241,
    y1: 14.6884,
    x2: 12.3513,
    y2: 14.6884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3555_79890",
    x1: 11.5274,
    y1: 15.6042,
    x2: 11.4427,
    y2: 16.0841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3555_79890",
    x1: 9.4952,
    y1: 18.7612,
    x2: 11.4596,
    y2: 22.1444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3555_79890",
    x1: 10.4866,
    y1: 20.8499,
    x2: 10.3366,
    y2: 21.5047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_3555_79890",
    x1: 11.7619,
    y1: 20.6907,
    x2: 12.2733,
    y2: 20.6907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_3555_79890",
    x1: 17.9485,
    y1: 19.9874,
    x2: 18.9836,
    y2: 22.0763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_3555_79890",
    x1: 17.1944,
    y1: 20.3615,
    x2: 18.2294,
    y2: 22.4504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_3555_79890",
    x1: 4.77105,
    y1: 1.10211,
    x2: 18.7158,
    y2: 12.2805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4573A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_3555_79890",
    x1: 17.274,
    y1: 7.29041,
    x2: 19.9863,
    y2: 7.29041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_3555_79890",
    x1: 7.16261,
    y1: 5.82566,
    x2: 12.8788,
    y2: 12.8968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_3555_79890",
    x1: 7.59184,
    y1: 10.7753,
    x2: 7.25308,
    y2: 12.5254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_3555_79890",
    x1: 15.9395,
    y1: 10.7753,
    x2: 16.2782,
    y2: 12.5254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_3555_79890",
    x1: 11.7122,
    y1: 1.25535,
    x2: 11.924,
    y2: 4.07816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4573A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_3555_79890",
    x1: 9.33482,
    y1: 1.40127,
    x2: 9.49007,
    y2: 2.05049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_3555_79890",
    x1: 10.3628,
    y1: 0.755195,
    x2: 11.4637,
    y2: 3.43687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_3555_79890",
    x1: 8.54401,
    y1: 2.38834,
    x2: 8.54401,
    y2: 3.00634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_3555_79890",
    x1: 7.68974,
    y1: 4.10148,
    x2: 8.11691,
    y2: 4.10148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_3555_79890",
    x1: 7.29304,
    y1: 5.01727,
    x2: 7.20834,
    y2: 5.49712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_3555_79890",
    x1: 5.25984,
    y1: 8.17529,
    x2: 7.22428,
    y2: 11.5585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_3555_79890",
    x1: 6.2513,
    y1: 10.263,
    x2: 6.10125,
    y2: 10.9179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_3555_79890",
    x1: 7.52659,
    y1: 10.1047,
    x2: 8.03795,
    y2: 10.1047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_3555_79890",
    x1: 13.7141,
    y1: 9.40051,
    x2: 14.7492,
    y2: 11.4894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_3555_79890",
    x1: 12.96,
    y1: 9.77456,
    x2: 13.9951,
    y2: 11.8635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupCoins);
export default __webpack_public_path__ + "static/media/Group_coins.3e7a1bf4dcfa66a46443da23ada303f4.svg";
export { ForwardRef as ReactComponent };